import {MathFunctions, SimplePoint, SimpleSize, SimpleSegment} from "./includes/mathHelper";
import * as paper from 'paper';
import {Point, Group, Path, Size, Segment} from "paper";
import {DrawDisplayData} from "./drawDisplayData";
import {EDIT_MODES, ApplicationState} from "./includes/applicationState";
import {DisplayFunctions} from "./includes/displayFunctions";
import {ApiService} from "./includes/apiService";
import {EEToolAdapterContextType} from "../types/EEToolAdapterContextType";

/*
Known funcs:
        drawDataFuncs.createAngleDisplay = createAngle;
        drawDataFuncs.createCrossMeasurementGroup = createCrossMeasurementGroup;
        drawDataFuncs.createMeasurementGroup = drawMeasurementLinesWithArrowsAndText;
        drawDataFuncs.remakeMeasurements = createMeasureLinesAndLabelLocations;
        drawDataFuncs.createEdgeGroup = drawEdge;
        drawDataFuncs.createBumpGroup = createBumpGroup;
        drawDataFuncs.createSplashGroup = Splash;
        drawDataFuncs.createCounterPath = makePathFromSegments;
        drawDataFuncs.getMeasurementVisibility = function () { return MeasurementVisible; };
        drawDataFuncs.createSink = addSinkToProject;
        drawDataFuncs.createSmoothingSegment = RadiusOrDiagonal;
        drawDataFuncs.createRadius = RadiusLine;

*/

interface EdgeColor {
    ec: EdgeColorData;
    group: any;
    point: paper.Point;
    pathIndex: number;
    pointTextObj: any;
}

class CounterTopArrClass {
    path: paper.Path;
    pathGroup: paper.Group;
    edgecolor: EdgeColor | null = null;
    sinkArr: any[] = [];
    radiusProductIDArr: any[] = [];
    cookTopSplashArr: any[] = [];

    constructor(path: paper.Path, pathGroup: paper.Group, edgecolor: EdgeColor) {
        this.path = path;
        this.pathGroup = pathGroup;
        this.edgecolor = edgecolor;
    }
}


export interface EdgeColorData {
    b1: number | undefined; // backsplashEdgeID,
    b1Text: string | undefined; //backsplashEdgeText
    p: number; // productID
    e1: (number | string); // edge1ID,
    e1Text: string | undefined;
    c: number | undefined; // colorID,
}


/*CounterTopArr members:
.path = Path
.pathGroup = Group
.sinkArr = {typeID:{typeEnum, sinkID}, group, angle, path}
.radiusProductIDArr = [] not saved.
.diagonalProductID = int not saved.
.edgecolor = { ec: {
        p: productID,
        c: colorID,
        e1: edge1ID,
        b1: backsplashEdgeID,
        pText: productDescritionText,
        cText: cText,
        e1Text: e1Text,
        b1Text: backsplashEdgeText
        
                   }
             }


segment members:
pairedCurve||pairedCurveIndex:
angleDrawDataObj: {pairedSegment || pairedSegmentIndex, group}
dataObjForMeasurements:  Group   Use: redrawInternals();
...
data = 
    {       crossSectionGroup, 
            bumpGroupData = {bumpGroup, side1, side2, tangentSide, bumpIn:(T/F) }, 
            isSmoothingOnly,
            ignoreSegment,
            smoothingData = {productID, depth, type: 1(radius)||2(diagonal), group, smoothingPointGroup:{position, remove()}},
            radiusData = {productID, depth, direction: -1||1, group, curve},
            endsRadius,
            splashData:{segment, {splashLengthInInches, }splashHeightInInches, {splashOffsetInInches, }group, selectedUpgrades:[{Id, }], lastProductTypeID},
            edgeData:{segment, {edgeLengthInInches, edgeOffsetInInches, }group, edgeID}
    }

*/

export interface IDrawDataFuncs {
    createCookTopSplash(sinkTypeData: any, currentPoint: any, angle: any, currentSize: any, path: any, segment: any, isNew: any): any;

    createCrossMeasurementGroup(segment: paper.Segment): paper.Group;

    createSmoothingSegment(segment: any, depth: any, dlgType: any, productId: any, forConvert?: any): any;

    createSplashGroup(splashData: any): any;

    getMeasurementVisibility(): any;

    createAngleDisplay(angleSegment: any, segPair: any): any;

    createBumpGroup(bumpGroupData: any): any;

    createCounterPath(segments: any): any;

    createEdgeGroup(edgeData: any): any;

    createSink(sinkTypeData: any, currentPoint: any, angle: any, currentSize: any, path: any): any;

    createRadius(curve: any, depth: any, radDirection: any): any;

    createMeasurementGroup(drawData: any, measureLineText: any): any;

    createEdgeLaminateGroup(edgeData: any): any;
}

export class DrawData {
    static EXACTHITOPTIONS = {          // Needed for exact (programmatic) hit tests.
        segments: true,
        stroke: true,
        fill: true,
        tolerance: 0
    };

    static HAS_RASTER_HITOPTIONS = {          //Accounts for weird bug.
        segments: true,
        stroke: true,
        fill: true,
        tolerance: 2
    };

    static TEST_POINT_SHIFT = 5;

    static ANGLE_DISPLAY_PIXEL_SHIFT = 20;

    static HITOPTIONS = {          // Needed for cursor hit test.
        segments: true,
        stroke: true,
        fill: true,
        tolerance: 3
    };

    static edgeColorDefault: EdgeColorData = {
        p: 710,
        //c: 'c1',
        e1: 'none',
        b1: undefined,
        b1Text: undefined,
        c: undefined,
        e1Text: undefined
    };

    static MEASUREMENT_LINE_SHIFT = 30;
    static MEASUREMENT_LABEL_SHIFT = 0;

    drawDataFuncs: IDrawDataFuncs;
    CounterTopArr: CounterTopArrClass[];
    drawDisplayDataObj: DrawDisplayData;
    FloatingItems = {sinkArr: <any[]>[]};
    FloatingCookTopSplashItems = {cookTopSplashArr: <any[]>[]};
    adapter: EEToolAdapterContextType;

    constructor(canvas: any, drawDataFuncs: IDrawDataFuncs, adapter: EEToolAdapterContextType) {
        this.drawDataFuncs = drawDataFuncs;
        this.CounterTopArr = [];
        this.adapter = adapter;
        this.drawDisplayDataObj = new DrawDisplayData(canvas, adapter);
    }

    getPathFromGroup(group: any) {
        var index = this.getPathIndex(group);
        if (index === -1) {
            return null;
        }
        return this.CounterTopArr[index].path;
    }

    static getGroupFromPath(path: any): paper.Group {
        return path.pathGroup;
    }

    getGroupFromPathIndex(pathIndex: any) {
        return this.CounterTopArr[pathIndex].pathGroup;
    }

    getPathIndex(path: any): number {
        if (!path) {
            return -1;
        }
        if (path.pathIndex) {
            return path.pathIndex;
        }
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            if (this.CounterTopArr[i].path == path || this.CounterTopArr[i].pathGroup == path)
                return i;
        }
        return -1;
    }

    getPathFromHitTest(point: any, hitOptions: any): any {
        //tunnel.
        if (!hitOptions) {
            hitOptions = DrawData.EXACTHITOPTIONS;
        }
        var hr;
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            hr = this.customHitTest(this.CounterTopArr[i].path, point, hitOptions);
            if (hr != null)
                return {path: this.CounterTopArr[i].path, hitResult: hr};
        }
        return null;
    }

    getPathByIndex(pathIndex: any) {
        return this.CounterTopArr[pathIndex].path;
    }

    getGroupByIndex(pathIndex: any) {
        return this.CounterTopArr[pathIndex].pathGroup;
    }

    getEdgeColorByIndex(pathIndex: any) {
        return this.CounterTopArr[pathIndex].edgecolor;
    }

    static getCrossSectionOwningSegments(path: any) {
        var segment;
        var retVal = [];
        for (var i = 0; i < path.segments.length; i++) {
            segment = path.segments[i];
            if (segment.data && segment.data.crossSectionGroup) {
                retVal.push(segment);
            }
        }
        return retVal;
    }

    getDefaultEdgeColor() {
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            if (this.CounterTopArr[i].edgecolor !== null) {
                let edgeColor = this.CounterTopArr[i].edgecolor;
                if (edgeColor && edgeColor.ec) {
                    return {...edgeColor.ec};
                }
            }
        }
    }

    getEdgeColorFromPath(selectedPath: any): EdgeColor | null {
        var ec = null;
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            if (this.CounterTopArr[i].path == selectedPath) {
                ec = this.CounterTopArr[i].edgecolor;
                break;
            }
        }

        return ec;
    }

    getPathFromEdgeColorGroup(pt: any) {
        var resPath = null;
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            var ec = this.CounterTopArr[i].edgecolor;
            if (ec && ec.group == pt) {
                resPath = this.CounterTopArr[i].path;
                break;
            }

        }
        return resPath;
    }

    getECLegendArr() {
        var retVal = [], singleEntry, singleE1, e1Text, singleB1, b1Text;
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            let edgecolor = this.CounterTopArr[i].edgecolor;
            if (edgecolor) {
                singleEntry = edgecolor.ec;

                if (singleEntry) {
                    singleE1 = singleEntry.e1;
                    e1Text = singleEntry.e1Text;
                    singleB1 = singleEntry.b1;
                    b1Text = singleEntry.b1Text;
                    if (singleE1 || singleB1) {
                        retVal.push({e1: singleE1, e1Text: e1Text, b1: singleB1, b1Text: b1Text + '*'});//, e2: singleE2, e2Text:e2Text });
                    }
                }
            }
        }
        return retVal;
    }

    getNextPathIndex() {
        return this.CounterTopArr.length;
    }

    static isEqualEC_PQG(priorEC: any, ec: any) {
        return ec.p == priorEC.p
    }

    isShapePath(selectedPath: any) {
        var bResult = false;
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            if (this.CounterTopArr[i].path == selectedPath) {
                bResult = true;
                break;
            }
        }
        return bResult;
    }

    addNewCounterData(p: any, pathGroup: any) {
        this.addPMEntry({
            path: p,
            pathGroup: pathGroup
        });
    }

    addPMEntry(pmEntry: any) {
        this.CounterTopArr.push(pmEntry);
        pmEntry.path.pathIndex = this.CounterTopArr.length - 1;
        pmEntry.path.pathGroup = pmEntry.pathGroup;
    }

    addCrossMeasureAtCurve(startSideSegment: any) {
        startSideSegment.data.crossSectionGroup = this.drawDataFuncs.createCrossMeasurementGroup(startSideSegment.path.segments[startSideSegment.index]);
    }

    createSmoothingPoint(segment: any) {
        this.drawDataFuncs.createSmoothingSegment(segment, segment.data.smoothingData.depth, segment.data.smoothingData.type, segment.data.smoothingData.productId);
    }

    addToCounterGroup(path: any, newGroupItem: any) {
        path.pathGroup.addChild(newGroupItem);
    }

    addToCounterGroupByIndex(pathIndex: any, newGroupItem: any) {
        this.CounterTopArr[pathIndex].pathGroup.addChild(newGroupItem);
    }

    addSplashToSegment(segment: any, splashData: any) {
        segment.data.splashData = splashData;
        if (segment.data.splashData.group) {
            segment.data.splashData.group.remove();
        }
        segment.data.splashData.group = this.drawDataFuncs.createSplashGroup(segment.data.splashData);
        segment.path.pathGroup.addChild(segment.data.splashData.group);
    }

    addEdgeToSegment(segment: any, edgeData: any) {
        segment.data.edgeData = edgeData;
        if (segment.data.edgeData.group) {
            segment.data.edgeData.group.remove();
        }
        segment.data.edgeData.group = this.drawDataFuncs.createEdgeGroup(segment.data.edgeData);
        segment.path.pathGroup.addChild(segment.data.edgeData.group);
    }

    addLaminateToSegment(segment: any, edgeLaminateProducts: any) {
        segment.data.edgeLaminateProducts = edgeLaminateProducts;
        if (segment.data.edgeLaminateProducts.group) {
            segment.data.edgeLaminateProducts.group.remove();
        }
        segment.data.edgeLaminateProducts.group = this.drawDataFuncs.createEdgeLaminateGroup({segment: segment});
        segment.path.pathGroup.addChild(segment.data.edgeLaminateProducts.group);
    }

    createNewPathGroup(p: any) {
        var pathGroup = new Group([p]);
        for (var i = 0; i < p.segments.length; i++) {
            if (p.segments[i].dataObjForMeasurements) {
                pathGroup.addChild(p.segments[i].dataObjForMeasurements);
            }
            if (p.segments[i].angleDrawDataObj) {
                pathGroup.addChild(p.segments[i].angleDrawDataObj.group);
                p.segments[i].angleDrawDataObj.group.bringToFront();
            }
            if (p.segments[i].data && p.segments[i].data.crossSectionGroup) {
                pathGroup.addChild(p.segments[i].data.crossSectionGroup);
            }
        }

        return pathGroup;
    }

    createEdgeColorLocation(path: any, ec?: any): paper.Point {
        var bottomMostPointY: number | null = null;
        var leftMostPointX: number | null = null;
        var ecLength;
        if (ec) {
            ecLength = ec.pText.length;
            if (ec.cText.length > ecLength) {
                ecLength = ec.cText.length;
            }
        } else {
            ecLength = 5;
        }
        var segments = path.segments, chosenSegPoint, chosenSeg;
        var tempSegPoint: paper.Point;
        chosenSeg = DrawData.getSmoothedStart(segments[0]);

        for (let i = 0; i < segments.length; i++) {
            tempSegPoint = DrawData.getSmoothedPoint(DrawData.getSmoothedStart(segments[i]));
            //if(tempSegPoint.x == leftMostPointX) {
            if (bottomMostPointY == null) {
                chosenSegPoint = tempSegPoint;
                chosenSeg = DrawData.getSmoothedStart(segments[i]);
                bottomMostPointY = chosenSegPoint.y;
            } else if (tempSegPoint.y < bottomMostPointY) {//Change Bottom to Top
                chosenSegPoint = tempSegPoint;
                chosenSeg = DrawData.getSmoothedStart(segments[i]);
                bottomMostPointY = chosenSegPoint.y;
            }
            //}
        }
        for (let i = 0; i < segments.length; i++) {
            tempSegPoint = DrawData.getSmoothedPoint(DrawData.getSmoothedStart(segments[i]));
            if (tempSegPoint.y === bottomMostPointY) {
                if (leftMostPointX == null) {
                    leftMostPointX = tempSegPoint.x;
                } else if (tempSegPoint.x > leftMostPointX) {//Change minX to maxX
                    chosenSegPoint = tempSegPoint;
                    chosenSeg = DrawData.getSmoothedStart(segments[i]);
                    leftMostPointX = chosenSegPoint.x;
                }
            }
        }
        var drawData = this.createCrossMeasurementGroupData(chosenSeg, DrawDisplayData.MATERIAL_LABEL_STYLE.fontSize * 1.5);
        var ecLoc = MathFunctions.getMidpoint(drawData.start, drawData.end);
        ecLength = ecLength * DrawDisplayData.MATERIAL_LABEL_STYLE.fontSize * 0.27;

        //upper right
        if (bottomMostPointY != null) {
            ecLoc.y = bottomMostPointY + 20;    //Move Text to outsite Path
        }
        if (leftMostPointX != null) {
            ecLoc.x = leftMostPointX - (ecLength + 40);
        }

        return ecLoc;
    }

    createCrossMeasurementGroupData(seg: any, offset: any, usePairedSegment: boolean = false) {
        var startSide = DrawData.makeSimpleCounterLine(seg);
        var path = seg.path;

        var normalVector = MathFunctions.reverseVector(this.createVectorShiftTowardsOutsidePath(path, startSide.point1, startSide.point2)).normalize(2 * DrawDisplayData.CANVASWIDTH);
        var midpoint;
        if (offset) {
            var length = MathFunctions.getLineLength(startSide);
            if (offset < 0) {
                midpoint = MathFunctions.addVectors(MathFunctions.getVectorBetweenPoints(startSide.point2, startSide.point1).normalize(Math.min(-1 * offset, length)), startSide.point2);
            } else {
                midpoint = MathFunctions.addVectors(MathFunctions.getLineVector(startSide).normalize(Math.min(offset, length)), startSide.point1);
            }
        } else {
            midpoint = MathFunctions.getMidpoint(startSide.point1, startSide.point2);
        }

        var overkillPointForIntersection = MathFunctions.addVectors(midpoint, normalVector);
        var pathLine = {
            point1: midpoint, point2: overkillPointForIntersection
        };

        var intersectedCurve, intersectedLine, endPoint, newEndPoint;
        if (!usePairedSegment) {
            for (var i = 0; i < path.curves.length; i++) {
                if ((i >= DrawData.getSmoothedEnd(seg).index || i <= DrawData.getSmoothedStart(seg).index) &&
                    MathFunctions.linesIntersect(pathLine, DrawData.makeSimpleCounterLine(path.segments[i]))) {
                    if (intersectedCurve == null) {
                        intersectedCurve = path.curves[i];
                        intersectedLine = DrawData.makeSimpleCounterLine(intersectedCurve.segment1);
                        endPoint = MathFunctions.getInterceptPoint(midpoint,
                            normalVector,
                            intersectedLine.point1,
                            MathFunctions.getVectorBetween(intersectedLine.point1, intersectedLine.point2));
                        if (usePairedSegment) {
                            break;
                        }
                    } else {
                        //find closest.
                        intersectedLine = DrawData.makeSimpleCounterLine(path.curves[i].segment1);
                        newEndPoint = MathFunctions.getInterceptPoint(midpoint,
                            normalVector,
                            intersectedLine.point1,
                            MathFunctions.getVectorBetween(intersectedLine.point1, intersectedLine.point2));
                        if (MathFunctions.getDistanceBetween(startSide.point1, newEndPoint) <
                            MathFunctions.getDistanceBetween(startSide.point1, endPoint)) {
                            intersectedCurve = path.curves[i];
                            endPoint = newEndPoint;
                        }
                    }
                }
            }
        }

        if (intersectedCurve == null) {
            if (seg.pairedCurve != undefined) {
                intersectedCurve = path.curves[seg.pairedCurve.index];
                intersectedLine = DrawData.makeSimpleCounterLine(intersectedCurve.segment1);
                endPoint = MathFunctions.getInterceptPoint(midpoint, normalVector, intersectedLine.point1, MathFunctions.getVectorBetween(intersectedLine.point1, intersectedLine.point2));
            }
        }

        return {
            isOuterMeasure: false,
            start: midpoint,
            end: endPoint,
            startSeg: seg,
            endSide: intersectedCurve?.segment1,
            startSide: null
        };
    }

    createVectorShiftTowardsOutsidePath(path: any, segStart: any, segEnd: any, testValue?: any, shiftValue?: any) {
        if (!testValue) {
            testValue = DrawData.TEST_POINT_SHIFT;
        }
        if (!shiftValue) {
            shiftValue = 1;
        }
        return DrawData.getVectorShiftTowardsOutsideArea((point: any) => this.isInSelectedPath(point, path), segStart, segEnd, testValue, shiftValue);
    }

    static getVectorShiftTowardsOutsideArea(isInAreaFunc: any, segStart: any, segEnd: any, testValue: any, shiftValue: any) {
        if (!shiftValue) {
            shiftValue = 1;
        }
        var midP = MathFunctions.getMidpoint(segStart, segEnd);

        var unitShift = MathFunctions.getUnitNormal(segStart, segEnd);
        var shiftTest = MathFunctions.multiplyVectorByScalar(unitShift, testValue);
        var shift = MathFunctions.multiplyVectorByScalar(unitShift, shiftValue);
        if (isInAreaFunc(MathFunctions.addVectors(midP, shiftTest))) {
            return MathFunctions.reverseVector(shift);
        }
        return shift;
    }

    //Edited at: 11/27/2015
    //Edited by: Truyen Nguyen
    setEdgeColorByPathIndex(pathIndex: any, ec: any, ecLoc?: paper.Point, doOthers: boolean = false) {
        //if (pathIndex == -1) { return;}

        //drawDataFuncs.setRadiusProductIDArr(ec.p, CounterTopArr[pathIndex]);

        if (!ecLoc) {
            ecLoc = this.createEdgeColorLocation(this.CounterTopArr[pathIndex].path, ec);
        }
        if (this.CounterTopArr[pathIndex].edgecolor == null) {
            var drawDataObj = {
                point: ecLoc,
                ec: ec,
                pathIndex: pathIndex,
                group: <paper.PointText | null>null,
                pointTextObj: <any>null
            };
            drawDataObj.group = DrawDisplayData.createEdgeColorPointText(drawDataObj);
            this.CounterTopArr[pathIndex].edgecolor = drawDataObj;
            this.addToCounterGroupByIndex(pathIndex, drawDataObj.group);
        } else {
            var priorEC = this.CounterTopArr[pathIndex].edgecolor;

            if (!DrawData.isEqualEC_PQG((<any>priorEC).ec, ec)) {
                var path = this.CounterTopArr[pathIndex].path;
                if (ec.e1 == 'none') {
                    DrawData.removeEdgesFromPath(path);
                }
                DrawData.removeMismatchedSinksForNewEC(this.CounterTopArr[pathIndex].sinkArr, ec.p1);
                DrawData.removeMismatchedSinksForNewEC(this.CounterTopArr[pathIndex].cookTopSplashArr, ec.p1);
                DrawData.removeAllSplashUpgrades(path);
                DrawData.removeAllEdgeLaminateProducts(path);
            }

            drawDataObj = <any>priorEC;
            drawDataObj.ec = ec;
            //drawDataObj.group = CounterTopArr[pathIndex].edgecolor.group;
            if (drawDataObj && drawDataObj.group) {
                drawDataObj.group.content = drawDataObj.ec.pText + "\n" + drawDataObj.ec.cText;
                drawDataObj.group.point = ecLoc;
                drawDataObj.pointTextObj = (<any>drawDataObj.group)[0];
            }
            this.CounterTopArr[pathIndex].edgecolor = drawDataObj;
            this.redrawInternals(this.CounterTopArr[pathIndex].path);
        }

        if (doOthers) {
            for (var i = 0; i < this.CounterTopArr.length; i++) {
                if (this.CounterTopArr[i].edgecolor == null)
                    this.setEdgeColorByPathIndex(i, ec, undefined, true);
            }
        }
    }

    setCurvePoints(curve: any, p1: any, p2: any) {
        if (curve.segment1.index != null && curve.segment2.index != null) {
            this.setSegmentPoint(curve.segment1, p1);
            this.setSegmentPoint(curve.segment2, p2);

            var segments = DrawData.getCrossSectionOwningSegments(curve.path);//update cross-sections
            for (var i = 0; i < segments.length; i++) {
                segments[i].data.crossSectionGroup.remove();
                this.addCrossMeasureAtCurve(segments[i]);
                curve.path.pathGroup.addChild(segments[i].data.crossSectionGroup);
            }
        }
    }

    setSegmentPoint(segment: any, newPoint: any) {
        if (segment.index != null && segment.next.index != null) {
            var oldPoint = new Point(segment.point);
            segment.point = newPoint;
            this.adjustCurveLengthObjects(segment.previous, segment.previous.point);
            this.adjustCurveLengthObjects(segment, oldPoint);
            this.redrawInternals(segment.path, {skipCurveData: true});
        }
    }

    makeAllowedBumpMovementFunction(bumpGroupData: any, didMoveObj: any) {
        return (e: any) => {
            if (e.event.button != 2) {
                var maxDeltaA = MathFunctions.reverseVector(MathFunctions.getVectorBetweenPoints(bumpGroupData.side1.previous.point, bumpGroupData.side1.point));
                var maxDeltaB = MathFunctions.getVectorBetweenPoints(bumpGroupData.side2.next.point, bumpGroupData.side2.next.next.point);
                var allowedVector = maxDeltaA;
                if (MathFunctions.isZeroVector(allowedVector)) {
                    allowedVector = maxDeltaB;
                    if (MathFunctions.isZeroVector(allowedVector)) {
                        return true;
                    }
                }
                var moveVector = e.delta.project(allowedVector);
                var distanceMoved = MathFunctions.getScalarLengthAlong(moveVector, maxDeltaA);
                if (distanceMoved > 0) {
                    if (distanceMoved > maxDeltaA.length - DisplayFunctions.PIXEL_INCH_RATE) {
                        moveVector = moveVector.normalize(Math.max(maxDeltaA.length - DisplayFunctions.PIXEL_INCH_RATE, 0));
                    }
                } else {
                    distanceMoved = MathFunctions.getScalarLengthAlong(moveVector, maxDeltaB);
                    if (distanceMoved <= 0) {
                        return true;
                    }
                    if (distanceMoved > maxDeltaB.length - DisplayFunctions.PIXEL_INCH_RATE) {
                        moveVector = moveVector.normalize(Math.max(maxDeltaB.length - DisplayFunctions.PIXEL_INCH_RATE, 0));
                    }
                }
                didMoveObj.didMove = true;
                bumpGroupData.bumpGroup.position = MathFunctions.addVectors(bumpGroupData.bumpGroup.position, moveVector);
                bumpGroupData.side1.point = MathFunctions.addVectors(bumpGroupData.side1.point, moveVector);
                bumpGroupData.tangentSide.point = MathFunctions.addVectors(bumpGroupData.tangentSide.point, moveVector);
                bumpGroupData.side2.point = MathFunctions.addVectors(bumpGroupData.side2.point, moveVector);
                bumpGroupData.side2.next.point = MathFunctions.addVectors(bumpGroupData.side2.next.point, moveVector);
                this.redrawInternals(bumpGroupData.side1.path);
            }
        };
    }

    adjustCurveLengthObjects(segment: any, measureLineText: any, skipRadiusData: boolean = false) {
        var pathGroup = segment.path.pathGroup;
        var drawDataObj;
        if (segment.dataObjForMeasurements) {
            segment.dataObjForMeasurements.remove();
        }
        if (!(segment.data.smoothingData || segment.data.ignoreSegment)) {
            drawDataObj = this.createOuterMeasurement(segment, measureLineText);
            DrawData.addOuterMeasurementToSegment(segment, drawDataObj); //allows for removal on redraw.
            this.addOuterMeasurementToGroup(segment.path.pathIndex, drawDataObj);
        }
        if (segment.data.smoothingData) {
            this.drawDataFuncs.createSmoothingSegment(segment, segment.data.smoothingData.depth, segment.data.smoothingData.type, segment.data.smoothingData.productId);
        }
        if (!skipRadiusData && segment.data.radiusData) {
            this.drawDataFuncs.createRadius(segment.path.curves[segment.index], segment.data.radiusData.depth, segment.data.radiusData.direction);
        }
        if (segment.data.edgeData) {
            this.addEdgeToSegment(segment, segment.data.edgeData);
        }
        if (segment.data.splashData) {
            this.addSplashToSegment(segment, segment.data.splashData);
        }
        if (segment.angleDrawDataObj) {
            drawDataObj = segment.angleDrawDataObj;
            drawDataObj.group.remove();
            drawDataObj = this.drawDataFuncs.createAngleDisplay(segment, drawDataObj.pairedSegment);
            pathGroup.addChild(drawDataObj.group);
            segment.angleDrawDataObj = drawDataObj;
        }
        if (segment.data.bumpGroupData) {
            //segment.data.bumpGroupData.bumpGroup.sendToBack();
            this.drawDataFuncs.createBumpGroup(segment.data.bumpGroupData);//alters yours.
        }
        if (segment.data.crossSectionGroup) {
            segment.data.crossSectionGroup.remove();
            this.addCrossMeasureAtCurve(segment);
            pathGroup.addChild(segment.data.crossSectionGroup);
        }
        if (segment.data.edgeLaminateProducts) {
            this.addLaminateToSegment(segment, segment.data.edgeLaminateProducts)
        }
    }

    createOuterMeasurement(segment: any, measureLineText?: any) {
        var line = DrawData.makeSimpleCounterLine(segment);
        var drawDataObj = this.createMeasureLinesAndLabelLocations(segment.path, line.point1, line.point2, !line.isSimple);
        drawDataObj.isOuterMeasure = true;
        drawDataObj.curve = segment.path.curves[segment.index];
        return this.drawDataFuncs.createMeasurementGroup(drawDataObj, measureLineText);
    }

    addOuterMeasurementToGroup(pathIndex: any, drawDataObj: any) {
        this.CounterTopArr[pathIndex].pathGroup.addChild(drawDataObj);
    }

    static addOuterMeasurementToSegment(segment: any, drawDataObj: any) {
        segment.dataObjForMeasurements = drawDataObj;
    }

    createMeasureLinesAndLabelLocations(path: any, p1: paper.Point, p2: paper.Point, useNoShift: any) {
        var retVal = {
            textLocation: <paper.Point | null>null,
            textContent: null,
            start: <paper.Point | null>null,
            end: <paper.Point | null>null,
            index: null,
            curve: null,
            isOuterMeasure: false
        };
        var shift = this.createVectorShiftTowardsOutsidePath(path, p1, p2, DrawData.TEST_POINT_SHIFT, 1);
        if (useNoShift) {
            retVal.start = p1;
            retVal.end = p2;
        } else {
            shift = shift.normalize(DrawData.MEASUREMENT_LINE_SHIFT);

            retVal.start = MathFunctions.addVectors(p1, shift);
            retVal.end = MathFunctions.addVectors(p2, shift);
        }

        retVal.textLocation = MathFunctions.addVectors(MathFunctions.getMidpoint(retVal.start, retVal.end), shift.normalize(DrawData.MEASUREMENT_LABEL_SHIFT));
        return retVal;
    }

    removeDrawData() {
        this.removeDrawCounters();
        this.removeDrawSinks();
        this.removeDrawCookTopSplashs();
    }

    removeDrawCounters() {
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            this.CounterTopArr[i].pathGroup.remove();
        }

    }

    removeDrawSinks() {
        //counter-attatched sinks already removed.
        if (this.FloatingItems.sinkArr) {
            for (var i = 0; i < this.FloatingItems.sinkArr.length; i++) {
                this.FloatingItems.sinkArr[i].group.remove();
            }
        }
    }

    /*
    Author: Truyen Nguyen
    Created at: 11/27/2015
    */
    removeDrawCookTopSplashs() {
        //counter-attatched sinks already removed.
        if (this.FloatingCookTopSplashItems.cookTopSplashArr) {
            for (var i = 0; i < this.FloatingCookTopSplashItems.cookTopSplashArr.length; i++) {
                this.FloatingCookTopSplashItems.cookTopSplashArr[i].group.remove();
            }
        }
    }

    removeSplash(splashDO: any) {
        splashDO.group.remove();
        splashDO.segment.data.splashData = null;
        this.tryRemoveBacksplashEdge(splashDO.segment.path);
    }

    static removeEdgeSelection(segment: any) {
        if (segment.data.edgeData) {
            if (segment.data.edgeData.group)
                segment.data.edgeData.group.remove();
            segment.data.edgeData = null;
            // also remove edge data from related corners if corners 
            let nextSegment = segment.next;
            if (nextSegment.data.smoothingData) {
                if (!nextSegment.next.data || !nextSegment.next.data.edgeData) {
                    this.removeEdgeSelection(nextSegment);
                }
            }
            let prevSegment = segment.previous;
            if (prevSegment.data.smoothingData) {
                if (!prevSegment.previous.data || !prevSegment.previous.data.edgeData) {
                    this.removeEdgeSelection(prevSegment);
                }
            }
        }
    }

    removeDiagonalFromSegment(segment: any, saveDeletedData: boolean = false) {
        var retVal = DrawData.removeDiagonalButSaveData(segment, !saveDeletedData);
        return retVal;
    }

    static removeDiagonalButSaveData(segment: any, skipTempSaveData: any, dontMoveData: boolean = false) {
        //retVal is isSmoothingOnly and ==segment.next. retVal is not deleted.
        //segment has .data.smoothingData
        //retVal has .data.tempSmoothingData
        var retVal = segment;
        var tempSegDataArr = [];
        if (segment.data.isSmoothingOnly) {
            segment = segment.previous;
        } else if (segment.data.smoothingData) {
            retVal = segment.next;
        }
        if (segment.data.smoothingData) {
            var smoothingData = segment.data.smoothingData;
            tempSegDataArr.push(DrawData.createSingleCurveSaveData(segment));
            DrawData.removeCurveDataObjects(segment);
            segment.path.removeSegment(segment.index);

            smoothingData.tempSegDataArr = tempSegDataArr;

            if (smoothingData.group) {
                smoothingData.group.remove();
            }
            if (!skipTempSaveData)
                retVal.data.tempSmoothingData = segment.data.smoothingData;
            retVal.point = smoothingData.smoothingPointGroup.position;
            retVal.handleIn = new Point(0, 0);
            retVal.handleOut = new Point(0, 0);
            smoothingData.smoothingPointGroup.remove();
            smoothingData.smoothingPointGroup = null;
            retVal.data.isSmoothingOnly = false;
            if (!dontMoveData)
                DrawData.moveCurveData(segment, retVal);
        }
        return retVal;
    }

    static moveCurveData(removeSeg: any, keepSeg: any) {
        if (removeSeg.data.edgeData) {
            keepSeg.data.edgeData = removeSeg.data.edgeData;
            keepSeg.data.edgeData.segment = keepSeg;
        } else if (removeSeg.data.splashData) {
            keepSeg.data.splashData = removeSeg.data.splashData;
            keepSeg.data.splashData.segment = keepSeg;
        }
    }

    removePath(path: any) {
        if (path == null) return;
        path = this.getPathFromGroup(path);
        var group = DrawData.getGroupFromPath(path);

        this.removePathData(path);
        group.remove();
        this.setMeasurementVisibility();
    }

    removePathData(p: paper.Path) {
        var i;
        for (i = 0; i < this.CounterTopArr.length; i++) {
            if (this.CounterTopArr[i].path === p) {
                this.CounterTopArr.splice(i, 1);
                break;
            }
        }

        this.renumberPathIndexes(i);
    }

    static removeCurveDataObjects(segment: any) {
        if (segment.data) {

            if (segment.data.bumpGroupData) {
                if (segment.data.bumpGroupData.bumpGroup) {
                    segment.data.bumpGroupData.bumpGroup.remove();
                }
            }
            if (segment.data.edgeLaminateProducts) {
                if (segment.data.edgeLaminateProducts.group) {
                    segment.data.edgeLaminateProducts.group.remove();
                }
            }
            if (segment.data.edgeData) {
                segment.data.edgeData.group.remove();
            }
            if (segment.data.splashData) {
                segment.data.splashData.group.remove();
            }
            if (segment.data.smoothingData && segment.data.smoothingData.group) {
                segment.data.smoothingData.group.remove();
            }
            if (segment.data.radiusData && segment.data.radiusData.group) {
                segment.data.radiusData.group.remove();
            }
            if (segment.data.crossSectionGroup) {
                segment.data.crossSectionGroup.remove();
            }
        }
        if (segment.angleDrawDataObj) {
            segment.angleDrawDataObj.group.remove();
        }
        if (segment.dataObjForMeasurements) {
            segment.dataObjForMeasurements.remove();
        }
    }

    static removeEdgesFromPath(p: any) {
        var segment;
        for (var i = 0; i < p.segments.length; i++) {
            segment = p.segments[i];
            DrawData.removeEdgeSelection(segment);
        }
    }

    removeCookTopSplashFromCounter(pathIndex: any, cookTopSplashData: any) {
        var arr = this.CounterTopArr[pathIndex].cookTopSplashArr;
        if (!arr) {
            return false;
        }
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == cookTopSplashData) {
                arr.splice(i, 1);

                cookTopSplashData.group.remove();
                return true;
            }
        }
        return false;
    }

    removeSinkFromCounter(pathIndex: any, sinkData: any) {
        var arr = this.CounterTopArr[pathIndex].sinkArr;
        if (!arr) {
            return false;
        }
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == sinkData) {
                arr.splice(i, 1);

                sinkData.group.remove();
                return true;
            }
        }
        return false;
    }

    removeFloatingCookTopSplash(cookTopSplashData: any, skipGroupObjRemove: boolean = false) {
        var arr = this.FloatingCookTopSplashItems.cookTopSplashArr;
        if (!arr) {
            return false;
        }
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == cookTopSplashData) {
                arr.splice(i, 1);
                if (!skipGroupObjRemove) {
                    cookTopSplashData.group.remove();
                }
                return true;
            }
        }

        return false;
    }

    removeFloatingSink(sinkData: any, skipGroupObjRemove: boolean = false) {
        var arr = this.FloatingItems.sinkArr;
        if (!arr) {
            return false;
        }
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == sinkData) {
                arr.splice(i, 1);
                if (!skipGroupObjRemove) {
                    sinkData.group.remove();
                }
                return true;
            }
        }

        return false;
    }

    deleteCookTopSplash(cookTopSplashData: any) {
        if (!this.removeFloatingCookTopSplash(cookTopSplashData)) {
            for (var i = 0; i < this.CounterTopArr.length; i++) {
                if (this.removeCookTopSplashFromCounter(i, cookTopSplashData)) {
                    return true;
                }
            }
            return true;
        }
        cookTopSplashData.group.remove();
        return false;
    }

    deleteSink(sinkData: any) {
        if (!this.removeFloatingSink(sinkData)) {
            for (var i = 0; i < this.CounterTopArr.length; i++) {
                if (this.removeSinkFromCounter(i, sinkData)) {
                    return true;
                }
            }
            return true;
        }
        sinkData.group.remove();
        return false;
    }

    detatchCookTopSplashFromCounter(pathIndex: any, cookTopSplashData: any) {
        if (this.removeCookTopSplashFromCounter(pathIndex, cookTopSplashData)) {
            paper.project.activeLayer.addChild(cookTopSplashData.group);
            cookTopSplashData.group.bringToFront();
            return true;
        }
        return false;
    }

    detatchSinkFromCounter(pathIndex: any, sinkData: any) {
        if (this.removeSinkFromCounter(pathIndex, sinkData)) {
            paper.project.activeLayer.addChild(sinkData.group);
            sinkData.group.bringToFront();
            return true;
        }
        return false;
    }

    createSaveDrawData() {
        var retVal = [];
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            retVal.push(DrawData.createPMEntrySaveData(this.CounterTopArr[i], i));
        }

        var floatingItems = {sinkArr: <any[]>[]};
        if (this.FloatingItems) {
            if (this.FloatingItems.sinkArr) {
                floatingItems.sinkArr = DrawData.createSinkArrSaveData(this.FloatingItems.sinkArr);
            }
        }

        var floatingCookTopSplashItems = {cookTopSplashArr: <any[]>[]};
        if (this.FloatingCookTopSplashItems) {
            if (this.FloatingCookTopSplashItems.cookTopSplashArr) {
                floatingCookTopSplashItems.cookTopSplashArr = DrawData.createCookTopSplashArrSaveData(this.FloatingCookTopSplashItems.cookTopSplashArr);
            }
        }
        return {
            counterTopArr: retVal,
            floatingItems: floatingItems,
            floatingCookTopSplashItems: floatingCookTopSplashItems
        };
    }

    static createCookTopSplashArrSaveData(cookTopSplashArr: any) {
        var retVal = [];
        var position, angle, segment, size, width, height, xLoc, yLoc;
        for (var i = 0; i < cookTopSplashArr.length; i++) {
            cookTopSplashArr[i].group.rotate(-1 * cookTopSplashArr[i].group.data.angle);
            xLoc = cookTopSplashArr[i].group.children['CookTopSplashTracker'].position.x;
            yLoc = cookTopSplashArr[i].group.children['CookTopSplashTracker'].position.y;
            if (xLoc == null || isNaN(xLoc) || yLoc == null || isNaN(yLoc)) {
                position = null;
            } else {
                position = new SimplePoint(xLoc, yLoc);
            }

            width = cookTopSplashArr[i].group.children['CookTopSplashTracker'].bounds.width;
            height = cookTopSplashArr[i].group.children['CookTopSplashTracker'].bounds.height;
            if (isNaN(width) || isNaN(height) || width <= 0 || height <= 0) {
                size = null;
            } else {
                size = new SimpleSize(width, height);
            }

            angle = cookTopSplashArr[i].angle;
            segment = cookTopSplashArr[i].segment;

            retVal.push({
                typeID: cookTopSplashArr[i].typeID,
                position: position,
                angle: angle,
                size: size,
                segment: segment
            });
            cookTopSplashArr[i].group.rotate(cookTopSplashArr[i].group.data.angle);
        }
        return retVal;
    }

    static createSinkArrSaveData(sinkArr: any) {
        var retVal = [];
        var position, angle, size, width, height, xLoc, yLoc;
        for (var i = 0; i < sinkArr.length; i++) {
            sinkArr[i].group.rotate(-1 * sinkArr[i].group.data.angle);
            xLoc = sinkArr[i].group.children['RasterTracker'].position.x;
            yLoc = sinkArr[i].group.children['RasterTracker'].position.y;
            if (xLoc == null || isNaN(xLoc) || yLoc == null || isNaN(yLoc)) {
                position = null;
            } else {
                position = new SimplePoint(xLoc, yLoc);
            }

            width = sinkArr[i].group.children['RasterTracker'].bounds.width;
            height = sinkArr[i].group.children['RasterTracker'].bounds.height;
            if (isNaN(width) || isNaN(height) || width <= 0 || height <= 0) {
                size = null;
            } else {
                size = new SimpleSize(width, height);
            }

            angle = sinkArr[i].angle;

            retVal.push({typeID: sinkArr[i].typeID, position: position, angle: angle, size: size});
            sinkArr[i].group.rotate(sinkArr[i].group.data.angle);
        }
        return retVal;
    }

    static createPMEntrySaveData(pmEntry: any, pathIndex: any) {
        var point;
        var path = DrawData.createCurveSaveData(pmEntry.path, pathIndex); //{pathIndex:pathIndex, segments: pmEntry.path.segments.concat([]) };
        //pathGroup
        var edgecolor = pmEntry.edgecolor;
        if (edgecolor) {
            edgecolor = {...edgecolor};
            edgecolor.ec = DrawData.copyEC(edgecolor.ec);
            point = edgecolor.point ? edgecolor.point : edgecolor.pointTextObj ? edgecolor.pointTextObj.point : edgecolor.group.point;
            edgecolor.point = {x: point.x, y: point.y};
            edgecolor.pointTextObj = null;
            edgecolor.group = null;
            edgecolor.pathIndex = pathIndex;
        }
        var sinkArr;
        if (pmEntry.sinkArr) {
            sinkArr = DrawData.createSinkArrSaveData(pmEntry.sinkArr);
        }

        var cookTopSplashArr;
        if (pmEntry.cookTopSplashArr) {
            cookTopSplashArr = DrawData.createCookTopSplashArrSaveData(pmEntry.cookTopSplashArr);
        }

        return {
            path: path,
            edgecolor: edgecolor,
            sinkArr: sinkArr ? sinkArr : [],
            cookTopSplashArr: cookTopSplashArr ? cookTopSplashArr : []
        };

    }

    static createSingleCurveSaveData(segment: any) {
        var angleDDO: any, data: any, drawDataObj: any, pairedCurveIndex: any, pairedAngleIndex: any, isOuterAngle: any;
        pairedCurveIndex = -1;
        pairedAngleIndex = -1;
        if (segment.data) {
            data = {};
            if (segment.data.bumpGroupData) {
                data.bumpGroupData = {
                    side1Index: segment.data.bumpGroupData.side1.index,
                    side2Index: segment.data.bumpGroupData.side2.index,
                    tangentSideIndex: segment.data.bumpGroupData.tangentSide.index,
                    bumpIn: segment.data.bumpGroupData.bumpIn
                };
            }
            if (segment.data.crossSectionGroup) {
                data.crossSectionGroup = {enabled: true};
            }

            data.isSmoothingOnly = segment.data.isSmoothingOnly;
            data.ignoreSegment = segment.data.ignoreSegment;
            if (segment.data.edgeLaminateProducts) {
                data.edgeLaminateProducts = {};
                if (segment.data.edgeLaminateProducts.capProductId) {
                    data.edgeLaminateProducts.capProductId = segment.data.edgeLaminateProducts.capProductId;
                }
                if (segment.data.edgeLaminateProducts.splashProductId) {
                    data.edgeLaminateProducts.splashProductId = segment.data.edgeLaminateProducts.splashProductId;
                }
            }

            if (segment.data.smoothingData) {
                data.smoothingData = DrawData.createSmoothingSaveData(segment.data.smoothingData);
            }
            if (segment.data.radiusData) {
                data.radiusData = DrawData.createRadiusSaveData(segment.data.radiusData);
            }
            data.endsRadius = segment.data.endsRadius;

            if (segment.data.splashData) {

                data.splashData = {};
                data.splashData.splashLengthInInches = segment.data.splashData.splashLengthInInches;
                data.splashData.splashOffsetInInches = segment.data.splashData.splashOffsetInInches;
                data.splashData.splashHeightInInches = segment.data.splashData.splashHeightInInches;
                data.splashData.selectedUpgrades = segment.data.splashData.selectedUpgrades;
                data.splashData.lastProductTypeID = segment.data.splashData.lastProductTypeID;
            }
            if (segment.data.edgeData) {

                data.edgeData = {};
                data.edgeData.edgeLengthInInches = segment.data.edgeData.edgeLengthInInches;
                data.edgeData.edgeOffsetInInches = segment.data.edgeData.edgeOffsetInInches;
                data.edgeData.edgeID = segment.data.edgeData.edgeID;
            }

        }

        if (segment.pairedCurve) {
            pairedCurveIndex = segment.pairedCurve.index;

        }
        isOuterAngle = segment.isOuterAngle;
        if (segment.pairedAngle) {
            pairedAngleIndex = segment.pairedAngle.index;

        }

        if (segment.angleDrawDataObj) {
            drawDataObj = {...segment.angleDrawDataObj};
            drawDataObj.group = null;
            drawDataObj.pairedSegmentIndex = drawDataObj.pairedSegment.index;
            drawDataObj.pairedSegment = null;
            angleDDO = drawDataObj;
        }

        return {
            point: new SimplePoint(segment.point.x, segment.point.y),
            handleIn: new SimplePoint(segment.handleIn.x, segment.handleIn.y),
            handleOut: new SimplePoint(segment.handleOut.x, segment.handleOut.y),
            pairedCurveIndex: (pairedCurveIndex == -1) ? null : pairedCurveIndex,
            pairedAngleIndex: (pairedAngleIndex == -1) ? null : pairedAngleIndex,
            angleDrawDataObj: angleDDO,
            isOuterAngle: isOuterAngle,
            data: data
        };
    }

    static createCurveSaveData(p: any, pathIndex: any) {
        var segments = [];
        for (var i = 0; i < p.segments.length; i++) {
            segments.push(DrawData.createSingleCurveSaveData(p.segments[i]));
        }
        return {pathIndex: pathIndex, segments: segments};
    }

    static createSmoothingSaveData(smoothingData: any) {
        var result = {
            depth: smoothingData.depth,
            type: smoothingData.type,
            smoothingPointGroup: {position: new SimplePoint(smoothingData.smoothingPointGroup.position.x, smoothingData.smoothingPointGroup.position.y)}
        };
        if (smoothingData.productId) {
            (result as any).productId = smoothingData.productId;
        }
        return result;
    }

    static createRadiusSaveData(radiusData: any) {
        return {depth: radiusData.depth, direction: radiusData.direction, trueRadius: radiusData.trueRadius};
    }

    restoreDrawData(dataObj: any) {
        if (dataObj.counterTopArr) {
            this.CounterTopArr = this.recreateDataFromSaveArray(dataObj.counterTopArr);
        } else {
            this.CounterTopArr = [];
        }
        this.FloatingItems = {sinkArr: []};
        this.FloatingCookTopSplashItems = {cookTopSplashArr: []};
        this.restoreSinkData(dataObj);
        this.restoreCookTopSplashData(dataObj);

        this.fullRedraw();
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            if (!this.CounterTopArr[i].radiusProductIDArr && this.CounterTopArr[i].edgecolor) {
                this.CounterTopArr[i].radiusProductIDArr = [];
                //drawDataFuncs.setRadiusProductIDArr(CounterTopArr[i].edgecolor.ec.p, CounterTopArr[i]);
            }
        }
    }

    restoreCookTopSplashData(dataObj: any) {
        if (dataObj.counterTopArr) {
            for (var i = 0; i < dataObj.counterTopArr.length; i++) {
                if (dataObj.counterTopArr[i].cookTopSplashArr) {
                    this.restoreCookTopSplashDataFromArr(dataObj.counterTopArr[i].cookTopSplashArr, this.CounterTopArr[i].path, i);
                }

            }
        }
    }

    restoreSinkData(dataObj: any) {
        if (dataObj.counterTopArr) {
            for (var i = 0; i < dataObj.counterTopArr.length; i++) {
                if (dataObj.counterTopArr[i].sinkArr) {
                    this.restoreSinkDataFromArr(dataObj.counterTopArr[i].sinkArr, this.CounterTopArr[i].path, i);
                }
            }
        }
    }

    restoreCookTopSplashDataFromArr(cookTopSplashArr: any, path: any, pathIndex: any) {

        var cookTopSplashData, position, angle, segment, size, tempA, tempB;
        for (var i = 0; i < cookTopSplashArr.length; i++) {

            if (cookTopSplashArr[i].position) {
                tempA = cookTopSplashArr[i].position.x;
                tempB = cookTopSplashArr[i].position.y;
                if (isNaN(tempA) || isNaN(tempB) || (tempA == 0 && tempB == 0)) {
                    position = this.createEdgeColorLocation(path);
                } //an inside point
                else {
                    position = new Point(tempA, tempB);
                }

            } else {
                position = this.createEdgeColorLocation(path); //an inside point
            }
            angle = cookTopSplashArr[i].angle;
            segment = cookTopSplashArr[i].segment;
            if (angle == null || isNaN(angle)) {
                angle = 0;
            }
            if (cookTopSplashArr[i].size) {
                tempA = cookTopSplashArr[i].size.width;
                tempB = cookTopSplashArr[i].size.height;
                if (isNaN(tempA) || isNaN(tempB) || tempA <= 0 || tempB <= 0) {
                    size = null;
                } else {
                    size = new Size(tempA, tempB);
                }
            } else {
                size = null;
            }
            if (size) {
                this.drawDataFuncs.createCookTopSplash(cookTopSplashArr[i].typeID, position, angle, size, path, segment, false);
            }
        }
    }

    restoreSinkDataFromArr(sinkArr: any, path: any, pathIndex: any) {

        var sinkData, position, angle, size, tempA, tempB;
        for (var i = 0; i < sinkArr.length; i++) {

            if (sinkArr[i].position) {
                tempA = sinkArr[i].position.x;
                tempB = sinkArr[i].position.y;
                if (isNaN(tempA) || isNaN(tempB) || (tempA == 0 && tempB == 0)) {
                    position = this.createEdgeColorLocation(path);
                } //an inside point
                else {
                    position = new Point(tempA, tempB);
                }

            } else {
                position = this.createEdgeColorLocation(path); //an inside point
            }
            angle = sinkArr[i].angle;
            if (angle == null || isNaN(angle)) {
                angle = 0;
            }
            if (sinkArr[i].size) {
                tempA = sinkArr[i].size.width;
                tempB = sinkArr[i].size.height;
                if (isNaN(tempA) || isNaN(tempB) || tempA <= 0 || tempB <= 0) {
                    size = null;
                } else {
                    size = new Size(tempA, tempB);
                }
            } else {
                size = null;
            }
            this.drawDataFuncs.createSink(sinkArr[i].typeID, position, angle, size, path);
        }
    }

    recreateDataFromSaveArray(dataArr: any): CounterTopArrClass[] {
        var retVal = [];
        for (var i = 0; i < dataArr.length; i++) {
            retVal.push(this.remakePMEntryFromSaveData(dataArr[i], i));
        }
        return retVal;
    }

    static copyEC(ec: any) {
        return {
            p: ec.p,
            c: ec.c,
            e1: ec.e1,
            pText: ec.pText,
            cText: ec.cText,
            e1Text: ec.e1Text,
            b1: ec.b1,
            b1Text: ec.b1Text
        };
    }

    remakePMEntry(pathIndex: any, newIndex: any) {
        var counterData = DrawData.createPMEntrySaveData(this.CounterTopArr[pathIndex], newIndex);
        return this.remakePMEntryFromSaveData(counterData, newIndex);
    }

    remakePMEntryFromSaveData(saveDataPMEntry: any, index: any): CounterTopArrClass {
        //no ref values, everything uses indexes. I.E. curve => curveIndex.
        var path = saveDataPMEntry.path;
        var segments = [], dataObj;
        for (var i = 0; i < path.segments.length; i++) {
            dataObj = path.segments[i];
            segments.push(new Segment({
                point: dataObj.point,
                handleIn: dataObj.handleIn,
                handleOut: dataObj.handleOut
            }));
        }

        if (!index && index !== 0) {
            index = saveDataPMEntry.path.pathIndex;
        }
        path = this.drawDataFuncs.createCounterPath(segments);
        var pathGroup = new Group([path]);
        path.pathIndex = index;
        path.pathGroup = pathGroup;
        var ec = saveDataPMEntry.edgecolor;
        if (ec) {
            var oldEC = ec;
            ec = {
                ec: DrawData.copyEC(oldEC.ec),
                point: (oldEC.point ? oldEC.point : oldEC.pointTextObj ? oldEC.pointTextObj.point : oldEC.group.point)
            };
            ec.pathIndex = index;
            ec.group = DrawDisplayData.createEdgeColorPointText(ec);
            pathGroup.addChild(ec.group);
        }
        DrawData.addCurveDataFromSaveData(saveDataPMEntry.path, path);
        this.restoreDrawingFromSaveData(path);
        let result = new CounterTopArrClass(path, pathGroup, ec);
        return result;
    }

    static addSingleCurveDataFromSaveData(segment: any, oldSegment: any) {
        var newPath = segment.path;
        segment.data = {};
        var curve = newPath.curves[segment.index];
        if (oldSegment.pairedCurveIndex || oldSegment.pairedCurveIndex === 0) {
            segment.pairedCurve = newPath.segments[oldSegment.pairedCurveIndex];
        }
        if (oldSegment.pairedAngleIndex || oldSegment.pairedAngleIndex === 0) {
            segment.pairedAngle = newPath.segments[oldSegment.pairedAngleIndex];
        }
        segment.isOuterAngle = oldSegment.isOuterAngle;

        if (oldSegment.data) {
            segment.data.isSmoothingOnly = oldSegment.data.isSmoothingOnly;
            segment.data.ignoreSegment = oldSegment.data.ignoreSegment;
            segment.data.endsRadius = oldSegment.data.endsRadius;
            if (oldSegment.data.radiusData) {
                segment.data.radiusData = oldSegment.data.radiusData;
                segment.data.radiusData.group = {
                    remove() {
                    }
                };
            }
            if (oldSegment.data.smoothingData) {
                segment.data.smoothingData = oldSegment.data.smoothingData;
                //segment.data.smoothingData.smoothingPointGroup = oldSegment.data.smoothingData.smoothingPointGroup;
                //segment.data.smoothingData.smoothingPointGroup.position = new Point(oldSegment.data.smoothingData.smoothingPointGroup.position.x, oldSegment.data.smoothingData.smoothingPointGroup.position.y);
                segment.data.smoothingData.smoothingPointGroup.remove = () => {
                };

                //segment.data.smoothingData.group = {remove:function(){}};
            }
            if (oldSegment.data.bumpGroupData && !segment.data.bumpGroupData) { //only do once, 3 sides share the data.
                var side1 = newPath.segments[oldSegment.data.bumpGroupData.side1Index],
                    side2 = newPath.segments[oldSegment.data.bumpGroupData.side2Index],
                    tangentSide = newPath.segments[oldSegment.data.bumpGroupData.tangentSideIndex];
                var sideArr = [side1, side2, tangentSide];
                var bumpGroupData = {
                    side1: side1,
                    side2: side2,
                    tangentSide: tangentSide,
                    bumpIn: oldSegment.data.bumpGroupData.bumpIn
                };
                for (var j = 0; j < sideArr.length; j++) {
                    //if (!sideArr[j].data) { sideArr[j].data = {}; }
                    sideArr[j].data.bumpGroupData = bumpGroupData;
                }

            }

            if (oldSegment.data.splashData) {
                segment.data.splashData = oldSegment.data.splashData;
                segment.data.splashData.segment = segment;
                segment.data.splashData.group = {
                    remove() {
                    }
                };
            }
            if (oldSegment.data.edgeData) {
                segment.data.edgeData = oldSegment.data.edgeData;
                segment.data.edgeData.segment = segment;
                segment.data.edgeData.group = {
                    remove() {
                    }
                };
            }

            segment.data.crossSectionGroup = oldSegment.data.crossSectionGroup;
            if (segment.data.crossSectionGroup) {
                segment.data.crossSectionGroup.remove = () => {
                };
            }

            if (oldSegment.data.edgeLaminateProducts) {
                segment.data.edgeLaminateProducts = {};
                if (oldSegment.data.edgeLaminateProducts.capProductId) {
                    segment.data.edgeLaminateProducts.capProductId = oldSegment.data.edgeLaminateProducts.capProductId;
                }
                if (oldSegment.data.edgeLaminateProducts.splashProductId) {
                    segment.data.edgeLaminateProducts.splashProductId = oldSegment.data.edgeLaminateProducts.splashProductId;
                }
                segment.data.edgeLaminateProducts.group = {
                    remove() {
                    }
                };
            }
        }
        segment.angleDrawDataObj = oldSegment.angleDrawDataObj;
    }

    static addCurveDataFromSaveData(oldPath: any, newPath: any) {
        for (var i = 0; i < oldPath.segments.length; i++) {
            DrawData.addSingleCurveDataFromSaveData(newPath.segments[i], oldPath.segments[i]);
        }
    }

    restoreDrawingFromSaveData(path: any) {
        var segment, pathGroup = path.pathGroup;
        for (var i = 0; i < path.segments.length; i++) {
            segment = path.segments[i];
            if (segment.data.smoothingData) {
                //var sd=segment.data.smoothingData;
                this.createSmoothingPoint(segment);
                //segment.data.smoothingData=sd;
            }

            if (segment.data.bumpGroupData && !segment.data.bumpGroupData.bumpGroup) { //only do once, 3 sides share the data.
                pathGroup.addChild(this.drawDataFuncs.createBumpGroup(segment.data.bumpGroupData));
            }


            if (segment.data.crossSectionGroup) {

                this.addCrossMeasureAtCurve(segment);
                pathGroup.addChild(segment.data.crossSectionGroup);
            }

            if (segment.data.edgeData) {
                this.addEdgeToSegment(segment, segment.data.edgeData);
            }

            if (segment.data.splashData) {
                this.addSplashToSegment(segment, segment.data.splashData);
            }

            if (segment.angleDrawDataObj) {

                segment.angleDrawDataObj = this.drawDataFuncs.createAngleDisplay(segment, path.segments[segment.angleDrawDataObj.pairedSegmentIndex]);
                pathGroup.addChild(segment.angleDrawDataObj.group);
            }
        }
    }

    setMeasurementVisibility(visibility?: any) {
        if (!visibility) {
            visibility = this.drawDataFuncs.getMeasurementVisibility();
        }
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            this.setSingleCounterMeasurementVisibility(i, visibility);
        }
        if (visibility.showEdgeLegends) {
            this.drawDisplayDataObj.addECLegendArrGroup(this.getECLegendArr());
        } else {
            this.drawDisplayDataObj.removeECLegendArrGroup();
        }
    }

    setSingleCounterMeasurementVisibility(pathIndex: number, visibility: any) {
        var counterData = this.CounterTopArr[pathIndex];
        var segments = counterData.path.segments, segment;

        for (let i = 0; i < segments.length; i++) {
            segment = segments[i];
            DrawData.setBackLayerVisibilityItems(segment, visibility);
        }

        if (counterData.sinkArr) {
            for (let i = 0; i < counterData.sinkArr.length; i++) {
                counterData.sinkArr[i].group.bringToFront();
            }
        }

        if (counterData.cookTopSplashArr) {
            for (let i = 0; i < counterData.cookTopSplashArr.length; i++) {
                counterData.cookTopSplashArr[i].group.bringToFront();
            }

        }

        if (visibility.pushMaterialColorLabelBack && counterData.edgecolor) {
            counterData.edgecolor.group.bringToFront();
        }

        for (let i = 0; i < segments.length; i++) {
            segment = segments[i];
            this.setMidLayerVisibilityItems(segment, visibility);

        }

        for (let i = 0; i < segments.length; i++) {
            segment = segments[i];
            DrawData.setFrontLayerVisibilityItems(segment, visibility);

        }
        if (!visibility.pushMaterialColorLabelBack && counterData.edgecolor) {
            counterData.edgecolor.group.bringToFront();
        }

        if (counterData.sinkArr) {
            for (let i = 0; i < counterData.sinkArr.length; i++) {
                if (counterData.sinkArr[i].typeID && counterData.sinkArr[i].typeID.typeEnum == 2) {
                    counterData.sinkArr[i].group.bringToFront(); // bring cutouts to front.
                }
            }
        }

        if (counterData.cookTopSplashArr) {
            for (let i = 0; i < counterData.cookTopSplashArr.length; i++) {
                if (counterData.cookTopSplashArr[i].typeID && counterData.cookTopSplashArr[i].typeID.typeEnum == 2) {
                    counterData.cookTopSplashArr[i].group.bringToFront(); // bring cutouts to front.
                }
            }

        }
    }

    static setBackLayerVisibilityItems(segment: any, visibility: any) {
        if (segment.data) {
            if (segment.data.radiusData) {
                segment.data.radiusData.group.visible = visibility.showRadiusMeasures;
                segment.data.radiusData.group.bringToFront();
            }
            if (segment.data.bumpGroupData) {
                if (visibility.showBumpHandles) {
                    DrawData.bringBumpHandleToFront(segment);

                } else {
                    segment.data.bumpGroupData.bumpGroup.visible = false;
                }

            }
            if (segment.data.splashData) {
                segment.data.splashData.group.children['path'].visible = visibility.showBacksplashPath;
                segment.data.splashData.group.children['label'].visible = visibility.showBacksplashMeasures;
                segment.data.splashData.group.children['label'].bringToFront();
            }

            if (segment.data.edgeLaminateProducts) {
                if (segment.data.edgeLaminateProducts.group) {
                    segment.data.edgeLaminateProducts.group.children['path'].visible = visibility.showEdges;
                }
            }

            if (segment.data.edgeData) {
                segment.data.edgeData.group.children['path'].visible = visibility.showEdges;
                //segment.data.edgeData.group.children['label'].visible = visibility.showEdgeLabels;
            }
        }
    }

    setMidLayerVisibilityItems(segment: any, visibility: any) {
        if (segment.data) {
            if (segment.data.crossSectionGroup) {
                if (!visibility.showBasicMeasurements)
                    segment.data.crossSectionGroup.remove();
                else {
                    var pathGroup = segment.path.pathGroup;
                    if (pathGroup.isChild(segment.data.crossSectionGroup)) {
                        segment.data.crossSectionGroup.visible = true;
                    } else {
                        this.addCrossMeasureAtCurve(segment);
                        pathGroup.addChild(segment.data.crossSectionGroup);
                    }
                    segment.data.crossSectionGroup.bringToFront();
                }
            }
        }
        if (segment.dataObjForMeasurements) {
            segment.dataObjForMeasurements.visible = visibility.showBasicMeasurements;
            segment.dataObjForMeasurements.bringToFront();
        }

    }

    static setFrontLayerVisibilityItems(segment: any, visibility: any) {

        if (segment.data) {
            if (segment.data.smoothingData) {
                if (segment.data.smoothingData.group) {
                    segment.data.smoothingData.group.visible = visibility.showRadiusMeasures;
                    segment.data.smoothingData.group.bringToFront();
                }
            }
            if (segment.data.radiusData) {
                var a = segment.data.radiusData.group.children["label"];
                if (a) {
                    a = a.children["radiusLabel"];
                    if (a) {
                        a.bringToFront();
                    }
                }

            }
        }

        if (segment.angleDrawDataObj) {
            segment.angleDrawDataObj.group.visible = visibility.showBasicMeasurements;
            segment.angleDrawDataObj.group.bringToFront();
        }

    }

    static bringBumpHandleToFront(segment: any) {
        if (segment.data) {
            if (segment.data.bumpGroupData) {
                var data = segment.data.bumpGroupData;
                data.bumpGroup.visible = true;
                try {
                    data.bumpGroup.bringToFront();//opacity is 0 anyway. Allows click.
                } catch (ex) {
                }

                for (var i = 0; i < 3; i++) {
                    switch (i) {
                        case 0: {
                            segment = data.side1;
                            break;
                        }
                        case 1: {
                            segment = data.side2;
                            break;
                        }
                        case 2: {
                            segment = data.tangentSide;
                            break;
                        }
                    }
                    if (segment.dataObjForMeasurements) {
                        segment.dataObjForMeasurements.visible = true;
                        var pt = segment.dataObjForMeasurements.children['label'];
                        pt.bringToFront();
                    }
                }
            }
        }
    }

    renumberPathIndexes(i: any) {
        if (!i)
            i = 0;
        for (i = 0; i < this.CounterTopArr.length; i++) {
            DrawData.renumberSinglePathIndex(this.CounterTopArr[i], i);
        }
    }

    static renumberSinglePathIndex(pmEntry: any, pathIndex: any) {
        var path = pmEntry.path;
        path.pathIndex = pathIndex;

        var ec = pmEntry.edgecolor;
        if (ec) {
            ec.pathIndex = pathIndex;
        }
    }

    static makeFullGroupWithoutSegments(segments: any) {
        var segment, group = new Group();
        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            //group.addChild(segment);
            if (segment.data.edgeData) {
                group.addChild(segment.data.edgeData.group);
            }
            if (segment.data.edgeLaminateProducts) {
                if (segment.data.edgeLaminateProducts.group) {
                    group.addChild(segment.data.edgeLaminateProducts.group);
                }
            }
            if (segment.data.splashData) {
                group.addChild(segment.data.splashData.group);
            }

            if (segment.dataObjForMeasurements) {
                group.addChild(segment.dataObjForMeasurements);
            }
            //if(segment.angleDrawDataObj)
            if (segment.data && segment.data.crossSectionGroup) {
                group.addChild(segment.data.crossSectionGroup);
            }
        }
        return group;
    }

    fullRedraw() {
        for (var i = 0; i < this.CounterTopArr.length; i++) {
            this.redrawInternals(this.CounterTopArr[i].path, {skipUpdate: true, dontResetMeasurementVisibility: true});
        }
        this.setMeasurementVisibility(this.drawDataFuncs.getMeasurementVisibility());
        paper.view.update();
    }

    static getcorrectMeasureLinesText(path: any) {
        var measureLinesText: any = {};
        var lineArr = [];
        var counter = 0;

        var bumpCounter = 0;
        var bumpDistance = 0;

        for (var i = 0; i < path.curves.length; i++) {
            var segment = path.segments[i];

            //This for normal lines
            if (!(segment.data.smoothingData || segment.data.ignoreSegment) && !segment.data.bumpGroupData) {
                var line = DrawData.makeSimpleCounterLine(segment);
                var textContent = DisplayFunctions.RoundPixelToInch(MathFunctions.getDistanceBetween(line.point1, line.point2));
                lineArr[counter++] = {isBump: false, isLine: true, index: segment.index, textContent: textContent};
            }

            //This for bump lines
            if (segment.data.bumpGroupData) {
                var line = DrawData.makeSimpleCounterLine(segment);
                var textContent = DisplayFunctions.RoundPixelToInch(MathFunctions.getDistanceBetween(line.point1, line.point2));

                //get first bump segment 
                if (bumpCounter == 0) {
                    var firstLine = DrawData.makeSimpleCounterLine(path.segments[i - 1]);
                    var firstTextContent = DisplayFunctions.RoundPixelToInch(MathFunctions.getDistanceBetween(firstLine.point1, firstLine.point2));
                    bumpDistance += firstTextContent;
                }

                if (bumpCounter == 1) {
                    bumpDistance += textContent;
                }

                if (bumpCounter < 3) {
                    //bumpDistance += textContent;
                    bumpCounter++;
                }

                //get last bump segment 
                if (bumpCounter == 3) {
                    var lastLine = DrawData.makeSimpleCounterLine(path.segments[i + 1]);
                    var lastTextContent = DisplayFunctions.RoundPixelToInch(MathFunctions.getDistanceBetween(lastLine.point1, lastLine.point2));
                    bumpDistance += lastTextContent;

                    lineArr[counter++] = {isBump: true, isLine: false, index: segment.index, textContent: bumpDistance};
                    bumpDistance = 0;
                    bumpCounter = 0;
                }
            }
        }

        //remove next line and past line of bump
        var maxLength = lineArr.length;
        for (var i = 0; i < maxLength; i++) {
            if (lineArr[i].isBump) {
                lineArr.splice(i - 1, 1);
                lineArr.splice(i, 1);
                maxLength -= 2;
            }
        }

        //Update segment data 
        if (lineArr.length == 4) {
            for (var index = 0; index <= 1; index++) {

                //for 2 lines that facing each other
                if (lineArr[index].isLine == true && lineArr[index + 2].isLine == true && lineArr[index].textContent != lineArr[index + 2].textContent) {
                    //calculate here!!!
                    measureLinesText[lineArr[index + 2].index] = {textContent: lineArr[index].textContent};
                }

                //for the bump face the line
                if (lineArr[index].isBump == true && lineArr[index + 2].isLine == true && lineArr[index].textContent != lineArr[index + 2].textContent) {
                    measureLinesText[lineArr[index + 2].index] = {textContent: lineArr[index].textContent};
                }

                if (lineArr[index + 2].isBump == true && lineArr[index].isLine == true && lineArr[index].textContent != lineArr[index + 2].textContent) {
                    measureLinesText[lineArr[index].index] = {textContent: lineArr[index + 2].textContent};
                }
            }
        }

        return measureLinesText;
    }

    redrawInternals(path: any, options?: any) {
        var skipCurveData = false;
        var dontResetMeasurementVisibility = false;
        var skipUpdate = false;
        if (options) {
            skipCurveData = options.skipCurveData;
            dontResetMeasurementVisibility = options.dontResetMeasurementVisibility;
            skipUpdate = options.skipUpdate;
        }

        var pmEntry = this.CounterTopArr[path.pathIndex];
        var ecObj = pmEntry.edgecolor;
        pmEntry.edgecolor = null;
        if (ecObj) {
            ecObj.group.remove();
            this.setEdgeColorByPathIndex(path.pathIndex, ecObj.ec);
        }

        if (!skipCurveData) {
            //Find measure lines segment      
            var measureLinesText: any = DrawData.getcorrectMeasureLinesText(path);
            for (let i = 0; i < path.segments.length; i++) {
                this.adjustCurveLengthObjects(path.segments[i], measureLinesText[i], true);
            }

            // we need to add radius only after all smoth points
            for (let i = 0; i < path.segments.length; i++) {
                let segment = path.segments[i];
                if (segment.data.radiusData) {
                    this.drawDataFuncs.createRadius(segment.path.curves[segment.index], segment.data.radiusData.depth, segment.data.radiusData.direction);
                }
            }
        }

        if (!dontResetMeasurementVisibility) {
            var visibility = this.drawDataFuncs.getMeasurementVisibility();
            this.setSingleCounterMeasurementVisibility(path.pathIndex, visibility);

            if (visibility.showEdgeLegends) {
                this.drawDisplayDataObj.addECLegendArrGroup(this.getECLegendArr());
            } else {
                this.drawDisplayDataObj.removeECLegendArrGroup();
            }
        }

        if (!skipUpdate) {
            paper.view.update();
        }
    }

    bringSinksToFront() {
        var arr: any[] = this.FloatingItems.sinkArr;
        if (arr) {
            for (var i = 0; i < arr.length; i++) {
                arr[i].group.bringToFront();
            }
        }

        for (var i = 0; i < this.CounterTopArr.length; i++) {
            if (this.CounterTopArr[i].sinkArr && this.CounterTopArr[i].sinkArr.length > 0) {
                for (var j = 0; j < this.CounterTopArr[i].sinkArr.length; j++) {
                    this.CounterTopArr[i].sinkArr[j].group.bringToFront();
                }
            }
        }
    }

    bringCookTopSplashsToFront() {
        var arr: any[] = this.FloatingCookTopSplashItems.cookTopSplashArr;
        if (arr) {
            for (var i = 0; i < arr.length; i++) {
                arr[i].group.bringToFront();
            }
        }

        for (var i = 0; i < this.CounterTopArr.length; i++) {
            if (this.CounterTopArr[i].cookTopSplashArr && this.CounterTopArr[i].cookTopSplashArr.length > 0) {
                for (var j = 0; j < this.CounterTopArr[i].cookTopSplashArr.length; j++) {
                    this.CounterTopArr[i].cookTopSplashArr[j].group.bringToFront();
                }
            }
        }
    }

    static convertCounterToSimpleCounter(path: any) {
        //remove radiuses and diagonals.
        var segments = path.segments, segment;
        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];

            if (segments[i].data.smoothingData) {
                segment = DrawData.removeDiagonalButSaveData(segment, false, true);
                if (segment.index < i) {
                    i = segment.index;
                }
            }
            if (segments[i].data.radiusData) {
                segment = DrawData.removeRadiusButSaveData(segment);
                if (segment.index < i) {
                    i = segment.index;
                }
            }
        }
    }

    convertCounterToComplexCounter(path: any) {
        var segments = path.segments, segment, data;
        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            data = segment.data;
            let tempSmoothingData = segment.data.tempSmoothingData;
            let tempRadiusData = segment.data.tempRadiusData;
            var initCurvesLenght = path.curves.length;

            if (tempSmoothingData) {
                segment = this.drawDataFuncs.createSmoothingSegment(segment, tempSmoothingData.depth, tempSmoothingData.type, tempSmoothingData.productId, true);
                DrawData.restoreTempCurveData(segment, tempSmoothingData.tempSegDataArr, true);
                data.tempSmoothingData = null;
            }
            if (tempRadiusData) {
                this.drawDataFuncs.createRadius(segment.path.curves[segment.index + segment.path.curves.length - initCurvesLenght], tempRadiusData.depth, tempRadiusData.direction);
                DrawData.restoreTempCurveData(segment, tempRadiusData.tempSegDataArr);
                data.tempRadiusData = null;
            }
        }
        this.redrawInternals(path);
    }

    static restoreTempCurveData(segment: any, curveDataArr: any, isSmoothing: boolean = false) {

        if (isSmoothing) {
            //segment = segment.previous;
            DrawData.removeCurveDataObjects(segment);
            for (var i = 0; i < curveDataArr.length; i++) {
                if (segment.data.smoothingData) {
                    var sd = segment.data.smoothingData;

                    DrawData.addSingleCurveDataFromSaveData(segment, curveDataArr[i]);
                    segment.data.smoothingData = sd;
                    //segment.data = curveDataArr[i];
                }
            }
        } else {
            segment = segment.next;
            for (var i = 0; i < curveDataArr.length; i++) {
                if (segment.data.ignoreSegment) {
                    //removeCurveDataObjects(curveDataArr[i]);
                    DrawData.addSingleCurveDataFromSaveData(segment, curveDataArr[i]);
                    //segment.data = curveDataArr[i];
                }
            }
        }
    }

    copyGeometryOfSegment(segment: any, segmentToCopy: any) {
        segment.point = segmentToCopy.point;
        segment.handleIn = segmentToCopy.handleIn;
        segment.handleOut = segmentToCopy.handleOut;
    }

    addRadiusData(curve: any, radiusData: any) {
        var segment = curve.segment1;
        segment.data.radiusData = radiusData;
        segment = segment.next;
        segment.data.endsRadius = true;
    }

    static removeRadius(curve: any) {
        var seg = curve.segment1;
        DrawData.removeRadiusButSaveData(seg, true);
    }

    static removeRadiusButSaveData(segment: any, skipTempSaveData: boolean = false) {

        if (segment.data.radiusData) {
            var tempSegDataArr = [];
            while (segment.next.data.ignoreSegment) {

                tempSegDataArr.push(DrawData.createSingleCurveSaveData(segment.next));

                DrawData.removeCurveDataObjects(segment.next);
                segment.path.removeSegment(segment.next.index);
            }
            if (!skipTempSaveData) {
                segment.data.tempRadiusData = segment.data.radiusData;
                segment.data.tempRadiusData.tempSegDataArr = tempSegDataArr;
            }
            segment.data.radiusData.group.remove();
            segment.data.radiusData = null;
            segment.next.data.endsRadius = false;
            var zeroP = new Point(0, 0);
            //segment.handleIn = zeroP;
            segment.handleOut = zeroP;
            segment.next.handleIn = zeroP;
            //segment.next.handleOut = zeroP;
        }
        return segment;
    }

    static setIgnoredCurve(curve: any) {
        var segment = curve.segment1;
        segment.data.ignoreSegment = true;
    }

    static isIgnoredCurve(curve: any) {
        return curve.segment1.data.ignoreSegment;
    }

    static createRadiusLegendText(depth: any, isCorner: boolean = false): string {
        if (isCorner) {
            if (depth <= .75) {
                return "rs";
            }
            if (depth <= 6) {
                return "r1";
            }
            if (depth <= 18) {
                return "r2";
            }
            if (depth <= 30) {
                return "r3";
            }
            if (depth <= 42) {
                return "r4";
            }
            return "r5";
        }
        if (depth <= 6) {
            return "r1";
        }
        if (depth <= 18) {
            return "r2";
        }
        if (depth <= 30) {
            return "r3";
        }
        if (depth <= 42) {
            return "r4";
        }
        return "r5";
    }

    static getSmoothedNextSegment(segment: any) {
        if (segment.data.smoothingData) {
            segment = segment.next.next;
        } else {
            segment = segment.next;
        }
        while (segment.data.ignoreSegment) {
            segment = segment.next;
        }
        return segment;
    }

    static getSmoothedPreviousSegment(segment: any) {
        if (segment.data.isSmoothingOnly) {
            segment = segment.previous.previous;
        } else {
            segment = segment.previous;
        }

        while (segment.data.ignoreSegment) {
            segment = segment.previous;
        }
        return segment;
    }

    static getSmoothedPoint(segment: any): paper.Point {
        if (segment.data.smoothingData) {
            return new Point(segment.data.smoothingData.smoothingPointGroup.position);
        }
        if (segment.previous.data.smoothingData) {
            return new Point(segment.previous.data.smoothingData.smoothingPointGroup.position);
        }
        return new Point(segment.point);
    }

    static isSmoothing(segment: any) {
        return (segment.data.isSmoothingOnly || segment.data.smoothingData);
    }

    static isRadius(segment: any) {
        return (segment.data.radiusData || segment.data.ignoreSegment);
    }

    static getSmoothedStart(segment: any) {
        var isSmoothingSeg = DrawData.isSmoothing(segment);
        var isRadiusSeg = DrawData.isRadius(segment);
        if (!isSmoothingSeg && !isRadiusSeg) {
            return segment;
        }
        if (isSmoothingSeg) {
            if (segment.data.smoothingData)
                return segment;
            else
                return segment.previous;
        }

        while (segment.data.ignoreSegment) {
            segment = segment.previous;
        }
        return segment;
    }

    static getSmoothedEnd(segment: any) {
        var isSmoothingSeg = DrawData.isSmoothing(segment);
        var isRadiusSeg = DrawData.isRadius(segment);
        if (!isSmoothingSeg && !isRadiusSeg) {
            return segment;
        }
        if (isSmoothingSeg) {
            if (segment.data.smoothingData)
                return segment.next;
            else
                return segment;
        }

        while (segment.data.ignoreSegment) {
            segment = segment.next;
        }
        return segment;
    }

    static getFullComplexCurve(curve: any) {
        var segment = curve.segment1;
        var startSeg, endSeg;
        if (segment.smoothingData || DrawData.isRadius(segment)) {
            startSeg = DrawData.getSmoothedStart(curve.segment1);
            endSeg = DrawData.getSmoothedEnd(curve.segment2);
        } else {
            startSeg = segment;
            endSeg = curve.segment2;
        }

        var arrLen = (endSeg.index - startSeg.index) + 1;
        if (arrLen <= 0) {
            arrLen = (endSeg.index + endSeg.path.segments.length - startSeg.index) + 1;
        }
        var retObj = {
            startSegment: startSeg, endSegment: endSeg, arrLength: arrLen,
            getPathIndexByArrIndex(i: any) {
                var retVal = i + this.startSegment.index;
                if (retVal >= this.startSegment.path.segments.length) {
                    retVal -= this.startSegment.path.segments.length;
                }
                return retVal;
            },
            getArrEntry(i: any) {
                return retObj.startSegment.path.segments[retObj.getPathIndexByArrIndex(i)];
            },
            createSegArr() {
                var retVal = [];
                for (var i = 0; i < retObj.arrLength; i++) {
                    retVal.push(retObj.getArrEntry(i));
                }
                return retVal;
            },
            forAllSegments(segFunc: any) {
                var retVal, segArr = retObj.createSegArr();
                for (var i = 0; i < retObj.arrLength; i++) {
                    retVal = segFunc(segArr[i]);
                    if (retVal != null) {
                        return retVal;
                    }
                }
            },
            forAllCurves(curveFunc: any) {
                var retVal, segArr = retObj.createSegArr(), curve;
                for (var i = 0; i < retObj.arrLength - 1; i++) {
                    curve = segArr[i].path.curves[segArr[i].index];
                    retVal = curveFunc(curve);
                    if (retVal != null) {
                        return retVal;
                    }
                }
            },
            getLength() {
                var retVal = 0;
                retObj.forAllCurves((c: any) => {
                    retVal += c.length;
                });
                return retVal;
            }
        };

        return retObj;
    }

    static copySegArr(segArr: any) {
        var retVal = [];
        for (var i = 0; i < segArr.length; i++) {
            retVal[i] = new Segment(new SimpleSegment(segArr[i]));
        }
        return retVal;
    }

    static makeSimpleCounterLine(segment: any) {
        var myPoint = DrawData.getSmoothedPoint(DrawData.getSmoothedStart(segment));
        var nextPoint = DrawData.getSmoothedPoint(DrawData.getSmoothedNextSegment(segment));
        var isSimple = (!DrawData.isRadius(segment) && !segment.data.tempRadiusData);

        return {point1: myPoint, point2: nextPoint, isSimple: isSimple};

    }

    static calculateAngle(segment: any) {
        //var angleVertexPoint=getSmoothedPoint(segment);
        var lineIn = DrawData.makeSimpleCounterLine(DrawData.getSmoothedPreviousSegment(segment)),
            lineOut = DrawData.makeSimpleCounterLine(segment);

        var curve1Point = lineIn.point1;
        var angleVertexPoint = lineIn.point2;
        var curve2Point = lineOut.point2;

        var v1 = MathFunctions.reverseVector(MathFunctions.getVectorBetweenPoints(curve1Point, angleVertexPoint)).normalize();
        var v2 = MathFunctions.getVectorBetweenPoints(angleVertexPoint, curve2Point).normalize();
        var anglePoint = MathFunctions.addVectors(angleVertexPoint, MathFunctions.addVectors(v1, v2).normalize(DrawData.ANGLE_DISPLAY_PIXEL_SHIFT));
        var angleContent = DisplayFunctions.customRound(MathFunctions.calculateAngleFromLines(lineIn, lineOut), 2);
        return {point: anglePoint, content: angleContent};
    }

    setBacksplashEdge(path: any, bsId: any, bsDescription: any) {
        //edgecolor.b1, edgecolor.b1Text
        var added = false;
        var edgecolor = (<any>this.CounterTopArr[path.pathIndex].edgecolor).ec;
        if (!edgecolor.b1) {
            edgecolor.b1 = bsId;
            edgecolor.b1Text = bsDescription;
            added = true;
        }

        if (added) {
            this.drawDisplayDataObj.addECLegendArrGroup(this.getECLegendArr());
        }
    }

    tryRemoveBacksplashEdge(path: any) {
        //edgecolor.b1, edgecolor.b1Text
        var temp;
        //var stillHasEdge = true;
        for (var i = 0; i < path.segments.length; i++) {
            temp = path.segments[i];
            if (temp.data.splashData) {
                temp = temp.data.splashData;
                if (temp.selectedUpgrades && temp.selectedUpgrades.length >= 1) {
                    //stillHasEdge = true;
                    return false;
                }
            }
        }

        var edgecolor = (<EdgeColor>this.CounterTopArr[path.pathIndex].edgecolor).ec;

        edgecolor.b1 = undefined;
        edgecolor.b1Text = undefined;


        this.drawDisplayDataObj.addECLegendArrGroup(this.getECLegendArr());
        return true;
    }

    removeBumps(path: any, bumpIn: any) {
        var segments = path.segments;
        var segment;
        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.bumpGroupData && (segment.data.bumpGroupData.bumpIn === bumpIn)) {
                this.removeBumpFromPath(segment.data.bumpGroupData);
            }
        }
    }

    removeBumpOuts(path: any) {
        this.removeBumps(path, false);
    }

    removeBumpIns(path: any) {
        this.removeBumps(path, true);
    }

    removeBumpFromPath(bumpGroupData: any) {
        DrawData.convertCounterToSimpleCounter(bumpGroupData.side1.path);
        var firstHalfCurve = bumpGroupData.side1.previous;
        var secondHalfCurve = bumpGroupData.side2.next;
        var removeArr = [bumpGroupData.side1, bumpGroupData.side2, bumpGroupData.tangentSide, secondHalfCurve];
        for (var i = 0; i < removeArr.length; i++) {
            DrawData.removeCurveDataObjects(removeArr[i]);
        }
        firstHalfCurve.path.removeSegments(firstHalfCurve.next.index, secondHalfCurve.next.index);
        bumpGroupData.bumpGroup.remove();
        bumpGroupData.bumpGroup = null;
        this.convertCounterToComplexCounter(firstHalfCurve.path);
        this.redrawInternals(firstHalfCurve.path);
    }

    getComplexCurveLength(curve: any) {
        var ccObj = DrawData.getFullComplexCurve(curve);
        return ccObj.getLength();
    }

    getProductQuoteGroup(path: any) {
        var edgecolor = this.CounterTopArr[path.pathIndex].edgecolor;
        if (edgecolor)
            return edgecolor.ec.p;
        return null;
    }

    customHitTest(paperObj: any, eventPoint: paper.Point, hitOptions: any) {
        if (!hitOptions) {
            hitOptions = DrawData.HITOPTIONS;
        }
        if (ApplicationState.CURRENTMODE === EDIT_MODES.SINK_COOKTOP) {
            hitOptions = DrawData.EXACTHITOPTIONS;
        }
        //var myPoint = eventPoint;//{x:(eventPoint.x - window.pageXOffset), y:(eventPoint.y - window.pageYOffset)};
        var hitResult = paperObj.hitTest(eventPoint, hitOptions); // Hit Test to recognize which object was selected.
        if (hitResult && hitResult.item && this.CounterTopArr[hitResult.item.pathIndex] && this.CounterTopArr[hitResult.item.pathIndex].sinkArr && this.CounterTopArr[hitResult.item.pathIndex].sinkArr.length > 0) {
            hitResult = paperObj.hitTest(eventPoint, DrawData.HAS_RASTER_HITOPTIONS);
        }
        if (hitResult && hitResult.item && this.CounterTopArr[hitResult.item.pathIndex] && this.CounterTopArr[hitResult.item.pathIndex].cookTopSplashArr && this.CounterTopArr[hitResult.item.pathIndex].cookTopSplashArr.length > 0) {
            hitResult = paperObj.hitTest(eventPoint, DrawData.HAS_RASTER_HITOPTIONS);
        }
        if (hitResult && hitResult.item && hitResult.item.className === "PointText") {
            if ((ApplicationState.CURRENTMODE === EDIT_MODES.DRAW_COUNTERS) && (hitResult.item.content.indexOf("\xB0") != -1)) { //clickable angle
                return hitResult;
            }
            var myChangePath = this.getPathFromEdgeColorGroup(hitResult.item);
            if (myChangePath != null) {
                return myChangePath.hitTest(eventPoint, hitOptions);
            } else {
                var myChangePathPair = this.getPathFromHitTest(eventPoint, hitOptions);
                if (myChangePathPair) {
                    return myChangePathPair.hitResult;
                }
            }
        }
        return hitResult;
    }

    pointVectorTowardsOutsidePath(path: any, vector: any, point: any) {
        if (this.isInSelectedPath(MathFunctions.addVectors(point, vector.normalize(DrawData.TEST_POINT_SHIFT)), path)) {
            return MathFunctions.reverseVector(vector);
        }
        return vector;
    }

    isInSelectedPath(point: any, selectedPath: any) {
        var hOptions = {          // It is needed when hit test.
            segments: false,
            stroke: false,
            fill: true,
            tolerance: 0
        };
        var hitResult = this.customHitTest(selectedPath, point, hOptions);
        return (hitResult && (hitResult.item == selectedPath));
    }

    sinkRemainsOnCounter(path: any, sinkPosition: any, sinkType: any) {
        if (sinkType != 2 && this.customHitTest(path, sinkPosition, DrawData.EXACTHITOPTIONS)) { //if is still inside countertop.
            return true;
        } else if (sinkType == 2) {//electric cutout.
            var segments = path.segments;
            var segment;
            var splashPath;
            for (var i = 0; i < segments.length; i++) {
                segment = segments[i];
                if (segment.data && segment.data.splashData && segment.data.splashData.group) {
                    splashPath = segment.data.splashData.group.children['path'];
                    if (this.customHitTest(splashPath, sinkPosition, DrawData.EXACTHITOPTIONS)) { //still counts as inside countertop.
                        return true;
                    }
                }
            }
        }
        return false;
    }

    static removeAllSplashUpgrades(path: any) {
        var segments = path.segments;
        var segment;
        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.splashData) {
                segment.data.splashData.selectedUpgrades = [];
            }
            if (segment.data.cookTopSplashData) {
                segment.data.cookTopSplashData.selectedUpgrades = [];
            }
        }
    }

    static removeAllEdgeLaminateProducts(path: any) {
        var segments = path.segments;
        var segment;
        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.edgeLaminateProducts) {
                delete segment.data.edgeLaminateProducts;
            }
        }
    }

    static removeMismatchedSinksForNewEC(sinkArr: any, productQG: any) {
        if (sinkArr && sinkArr.length > 0) {

            var allowedSinks = ApiService.getSinkListFromServer(productQG);
            for (var i = 0; i < sinkArr.length; i++) {
                if (sinkArr[i].typeID.typeEnum == 1) {
                    if (allowedSinks.indexOf(sinkArr[i].typeID.sinkID) == -1) {
                        sinkArr.splice(i, 1);
                        i = i - 1;
                    }
                }
            }
        }
    }

    static roundToAllowedAngle(deg: number): number {
        //16 allowed angles: 0, 22.5, 45, etc.

        deg = deg / 360;//a number between 0 and 1.
        deg = deg * 16; //between 0 and 16
        deg = Math.round(deg);//..with no decimals.
        deg = (deg / 16) * 360; //back to one of allowed numbers in degrees.
        deg = deg % 360; //under 360
        return deg;
    }

    rotateHangingSinks(pathIndex: any, angle: any, point: any) {
        var sinkArr = this.CounterTopArr[pathIndex].sinkArr;
        var path = this.CounterTopArr[pathIndex].path;
        if (sinkArr) {
            for (var i = 0; i < sinkArr.length; i++) {
                if (!this.sinkRemainsOnCounter(path, sinkArr[i].group.position, sinkArr[i].typeID.typeEnum)) {
                    //Sink is no longer on CounterTop: rotate sink.
                    sinkArr[i].group.rotate(angle, point);

                    DrawData.updateRasterAngle(sinkArr[i], angle);
                }
            }
        }
    }

    rotateRasterData(pathIndex: any, angle: any) {
        var sinkArr = this.CounterTopArr[pathIndex].sinkArr;
        if (sinkArr) {
            for (var i = 0; i < sinkArr.length; i++) {
                DrawData.updateRasterAngle(sinkArr[i], angle);
            }
        }
    }

    static updateRasterAngle(sink: any, angle: any) {
        sink.angle += angle;
        var sign = (sink.angle > 0) ? 1 : -1;
        sink.angle = (Math.abs(sink.angle) % 360) * sign;
    }

    addSplashUpgradeSelection(upgradeItem: any, data: any) {
        var hasData = (data.selectedUpgrades && data.selectedUpgrades.length >= 1);
        data.selectedUpgrades = [];

        data.selectedUpgrades.push(upgradeItem);
        this.setBacksplashEdge(data.segment.path, upgradeItem.Id, upgradeItem.Description);
        if (data.selectedUpgrades.length >= 1 && !hasData) {
            data.group.children['label'].content += '*';
        }
    }

    removeSplashUpgradeSelection(upgradeItemIndex: any, data: any) {
        data.selectedUpgrades.splice(upgradeItemIndex, 1);

        this.tryRemoveBacksplashEdge(data.segment.path);
        if (data.selectedUpgrades.length == 0) {
            var l = data.group.children['label'].content;
            l = l.slice(0, l.length - 1);
            data.group.children['label'].content = l;
        }
    }

    rotatePath(group: any, angle: any) {
        if (group != null) {
            var path = this.getPathFromGroup(group);
            if (path != null) {
                var center = new Point(path.position);
                group.rotate(angle, center);
                // was this.drawDataObj.rotateRasterData(path.pathIndex, angle);
                this.rotateRasterData(this.getPathIndex(path), angle);
                //checkSidesForConsistency(path);
                this.redrawInternals(path);
            }
        }
    }

    duplicatePath(path: any) {
        var index = this.getPathIndex(path);
        var newIndex = this.getNextPathIndex();
        this.addPMEntry(this.remakePMEntry(index, newIndex));
        var group = this.getGroupByIndex(newIndex);
        group.position = MathFunctions.addVectors(group.position, new Point(50, 50));
        this.redrawInternals(this.getPathByIndex(newIndex));
    }
}
